module.exports = __webpack_public_path__ + "assets/img/index-intro-xs-02@2x.34b546d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-xs-02@2x.png
// module id = 904
// module chunks = 1